import { AppState } from 'src/store';

export const devtoolsSelectors = {
  isDevtoolsOpen: (state: AppState) => state.devtools.isDevtoolsOpen,
  isTranslationsHighlighted: (state: AppState) => state.devtools.isTranslationsHighlighted,
  isReactQueryDevtoolsActive: (state: AppState) => state.devtools.isReactQueryDevtoolsActive,
};
